module.exports = __webpack_public_path__ + "static/media/tick.c4ac4f51.svg";